/* FBTY swatch basket display.
   Shows the chosen fabric's photo and name for "Fabric Swatch" lines in the slide-out basket
   and on the basket page. Photo comes from the swatch line's hidden _image property
   (set by snippets/swatch-button.liquid); older lines without it get the generic swatch graphic. */
(function () {
  if (window.fbtySwatchCart) return;
  window.fbtySwatchCart = true;

  var SWATCH_VARIANT = 59276770115919;
  var FALLBACK = window.fbtySwatchFallback || '';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var timer = null;

  function setImg(img, src, fabric) {
    if (!img || !src || img.getAttribute('src') === src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('data-src');
    img.classList.remove('lazyload');
    img.setAttribute('src', src);
    img.setAttribute('alt', fabric ? 'Swatch: ' + fabric : 'Fabric swatch');
  }

  function fix(el, item, imgSel, titleSel) {
    if (!el || !item || item.variant_id !== SWATCH_VARIANT) return;
    var props = item.properties || {};
    var fabric = props.Fabric || '';
    setImg(el.querySelector(imgSel), props._image || FALLBACK, fabric);
    if (titleSel && fabric) {
      var a = el.querySelector(titleSel);
      if (a && a.getAttribute('data-fbty') !== fabric) {
        a.setAttribute('data-fbty', fabric);
        a.textContent = 'Swatch: ' + fabric;
      }
    }
  }

  function apply() {
    var drawerItems = document.querySelectorAll('.js-mini-cart-content .mini-cart-item');
    var pageRows = document.querySelectorAll('#CartProducts > tr');
    if (!drawerItems.length && !pageRows.length) return;
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.js-mini-cart-content').forEach(function (box) {
          box.querySelectorAll('.mini-cart-item').forEach(function (el, i) {
            fix(el, cart.items[i], '.mini-cart-image img', '.mini-cart-meta .mb-1 a');
          });
        });
        document.querySelectorAll('#CartProducts > tr').forEach(function (el, i) {
          fix(el, cart.items[i], '.cart__image img', null);
        });
      })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 120);
  }

  function watch() {
    var targets = document.querySelectorAll('.js-mini-cart-content, #CartProducts');
    if (window.MutationObserver) {
      var obs = new MutationObserver(schedule);
      targets.forEach(function (t) { obs.observe(t, { childList: true }); });
    }
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
